import { defineMessages } from '@cookbook/solid-intl'

// Split out of `join-page.messages.en.js` for the same boot-chunk reason as
// `property-new-page-routing.messages.en.js` (TENANT-5036 bundle audit).
export const messages = {
    titleMessage: defineMessages({
        defaultMessage: 'Join Lodgr | Lodgr',
        id: 'JoinPage.titleMessage',
    }),
}
